
















import * as vr from '@/helpers/validation';
import { ValidationRules } from '@/api/schema';

import PromoCampaignFormMixin from './PromoCampaignFormMixin';

export default {
  name: 'PromoCampaignFormCompany',
  mixins: [PromoCampaignFormMixin],

  computed: {
    rules(): ValidationRules {
      return {
        campaignNameInput: [vr.required, vr.minLength]
      };
    }
  }
};
